var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile-desktop-banner"},[_c('span',{staticClass:"banner-text"},[_vm._v("For the best experience, use a desktop browser.")]),_c('a',{staticClass:"banner-link",attrs:{"href":_vm.mailtoLink}},[_vm._v("Email me this link")])])
}
var staticRenderFns = []

export { render, staticRenderFns }